import styled from 'styled-components'
import {StepperDefaultStyle, StepperResumeStyle} from './StepperProps'

export const ContainerColumn = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 100%;
  font-family: ${({theme}) => theme.fonts.primary};
`
export const StepperChildrenContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  font-family: ${({theme}) => theme.fonts.primary};
  overflow: hidden;
`

export const ContainerRow = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  width: 70%;
  font-family: ${({theme}) => theme.fonts.primary};
`
export const StepperStageTitle = styled.p`
  color: #8e8e8e;
  text-transform: uppercase;
  font-weight: 400;
  font-size: 10px;
  font-style: normal;
  line-height: 5px;
  font-family: ${({theme}) => theme.fonts.primary};
`

export const StepperTitle = styled.p<StepperResumeStyle>`
  color: ${({status, theme}) => (status === 'disabled' ? theme.stepper.pendingColor : '#272727')};
  font-size: 12px;
  font-style: normal;
  font-weight: bold;
  line-height: 8px;
  font-family: ${({theme}) => theme.fonts.primary};
`

export const StepperResume = styled.p<StepperResumeStyle>`
  color: ${({color, status, theme}) =>
    color ? color : status === 'concluded' ? theme.stepper.concludedColor : status === 'active' ? theme.stepper.activedColor : theme.stepper.pendingColor};
  font-size: 10px;
  font-style: normal;
  font-weight: 400;
  line-height: 18px;
  min-height: 18px;
  font-family: ${({theme}) => theme.fonts.primary};
`

export const StepperContainer = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
`

export const StepperDefault = styled.div<StepperDefaultStyle>`
  width: 85%;
  height: 85%;
  border-radius: ${({borderRadius}) => borderRadius ?? '6px'};
  background-color: ${({backgroundColor, status, theme}) =>
    backgroundColor
      ? backgroundColor
      : status === 'concluded'
        ? theme.stepper.concludedColor
        : status === 'active'
          ? theme.stepper.activedColor
          : theme.stepper.pendingColor};

  display: flex;
  justify-content: center;
  align-items: center;
`

export const StepperBorder = styled.div<StepperDefaultStyle>`
  min-width: 40px;
  min-height: 30px;
  border: ${({border, status, theme}) =>
    border
      ? border
      : status === 'concluded'
        ? `1px solid  ${theme.stepper.concludedColor}`
        : status === 'active'
          ? `1px solid  ${theme.stepper.activedColor}`
          : `1px solid  ${theme.stepper.pendingColor}`};
  padding: ${({padding}) => padding ?? `1px`};
  width: ${({width}) => width ?? '40px'};
  height: ${({height}) => height ?? '40px'};
  border-radius: ${({borderRadius}) => borderRadius ?? '8px'};
  display: flex;
  justify-content: center;
  align-items: center;
`

export const StepperTitlesContainer = styled.div`
  padding: 10px 0;
`
